import React from 'react';

import { groupHeader } from './FilterPanelStyles';


export function GroupHeader(props: { readonly text: string }) {
  // TODO what header level should we use here?
  return <div className={groupHeader}>{props.text}</div>;
}
